module.exports = __webpack_public_path__ + "static/img/uav_yellow.c23cd490.svg";